
import { Loader } from "lucide-react";

export function CompanyLoading() {
  return (
    <div className="flex justify-center items-center py-8">
      <Loader size={32} className="animate-spin text-muted-foreground" />
      <span className="ml-2 text-muted-foreground">Loading company information...</span>
    </div>
  );
}
